import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, Typography } from "@mui/material";
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import colors from '../../../assets/theme/base/colors';
import { CustomDialogTitle } from "../../Common/Custom/CustomDialogTitle";
import { useState } from 'react';
import theme from "../../../assets/theme";
import { Auth } from '../../../Component/Api/Auth/AuthService';
import { useRecoilState } from "recoil";
import { UserAtom } from "../../../State/user.Atom";
import CloseIcon from '@mui/icons-material/Close';


const { dark, primary } = colors;

interface IProps {
    showIntroModal: boolean;
    closeIntroModal: () => void;
}

export const VerificationHubWelcomeModal = (props: IProps) => {
    const [currentUser, setCurrentUser] = useRecoilState(UserAtom);
    const [hideVerificationHubModal, setHideVerificationHubModal] = useState(currentUser.hideVerificationHubModal);

    const handleCheckboxChange = (checked: boolean) => {
        Auth.UpdateVerificationModalSelection(checked).then(result => {
            setHideVerificationHubModal(checked);
            const updatedUser = {
                ...currentUser,
                HideVerificationHubModal: checked,
            };
            setCurrentUser(updatedUser);

        })
    };


    return (
        <Dialog disableEnforceFocus open={props.showIntroModal} aria-labelledby="form-dialog-title" maxWidth='lg' style={{ color: primary.main }}>
            <DialogTitle>
                <Typography variant="h4" sx={{ color: `${primary.main}` }}>
                    Welcome to our Verification Hub
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => props.closeIntroModal()}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ width: '800px' }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        backgroundColor: "#F0F2F5",
                        borderRadius: "10px"
                    }}
                >
                    <img
                        src={`${process.env.PUBLIC_URL}/img/VerificationHub.svg`}
                        style={{ maxWidth: '100%', marginTop: '10px' }}>
                    </img>
                </Box>
                <Grid container paddingTop={1} >
                    <MDTypography variant='subtitle2' width="100%" >
                        Seamlessly submit your data for verification to partnered Verification Agencies in a few clicks while
                        skipping the hassle of formatting your data in a specific way and removing the risk of human error
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' width="100%" style={{ color: primary.main }}>
                        <strong>APPOINT YOUR VERIFICATION AGENCY (OUT OF SYSTEM)</strong>
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1} >
                    <MDTypography variant='subtitle2' width="100%">
                        If you're utilising a partnered agency, please ensure the following application process has been completed
                        before submitting your scorecard:
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <ol style={{ color: dark.main }}>
                        <li>
                            <MDTypography variant='subtitle2'>
                                <strong>Contact your Chosen Agency:</strong> Reach out to the agency you have selected.
                            </MDTypography>
                        </li>
                        <li>
                            <MDTypography variant='subtitle2'>
                                <strong>Complete the Application Form:</strong> Complete the application form provided by the agency.
                            </MDTypography>
                        </li>
                        <li>
                            <MDTypography variant='subtitle2'>
                                <strong>Approve the Proposal:</strong> Review and accept the agency's proposal.
                            </MDTypography>
                        </li>
                        <li>
                            <MDTypography variant='subtitle2'>
                                <strong>Finalize the Verification Agreement:</strong> Complete and sign the verification agreement.
                            </MDTypography>
                        </li>
                    </ol>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' width="100%" style={{ color: primary.main }} >
                        <strong>SELECT YOUR VERIFICATION AGENCY</strong>
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' width="100%">
                        First browse through the list of Verification Agencies and the benefits of selecting a partnered agency.
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' width="100%" style={{ color: primary.main }}>
                        <strong>SELECT YOUR SCORECARD FOR SUBMISSION</strong>
                    </MDTypography>
                </Grid>
                <Grid container paddingTop={1}>
                    <MDTypography variant='subtitle2' width="100%">
                        Then select your scorecard and submit it for verification.
                    </MDTypography>
                </Grid>

            </DialogContent>
            <DialogActions >
                <Box sx={{ display: 'flex', justifyContent: "space-between", width: '100%' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hideVerificationHubModal}
                                onChange={(e) => handleCheckboxChange(e.target.checked)}
                                name="hideVerificationHubModalCheckBox"
                                color="primary"
                                sx={{
                                    '& .MuiSvgIcon-root': {
                                        border: `2px solid ${theme.palette.secondary.main}`,
                                    },
                                }}
                            />
                        }
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="body2">
                                    Don't show me this again.
                                </Typography>
                            </Box>
                        }
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => props.closeIntroModal()}>
                        Get started
                    </Button>
                </Box>

            </DialogActions>
        </Dialog>
    )
}
